import * as React from "react";
import { Button, Card, Elevation, Overlay,Classes,Intent,H3 } from "@blueprintjs/core";

let Logo ="login.png";


export default class PanelNom extends React.Component <{}> {
  
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.props.onChange(undefined);
    //this.props.setState({value:undefined})
    
  }
  
  componentDidMount () {
		const node = document.querySelectorAll('button');
    node.forEach(element => {
      //console.log(element);
      const item=element.querySelectorAll('span')
      if(item[0]!= undefined)if(item[0].innerHTML=="Next")item[0].innerHTML="Etape suivante";
      if(item[0]!= undefined)if(item[0].innerHTML=="Back")item[0].innerHTML="Etape précédente";
     // console.log(item);
    });
    //const node2=node.querySelectorAll('button');
    
  }
  handleChange(e) {
    this.props.onChange(e.target);
  }

  render() {
    
    return (
      <div style={{padding:'10px'}}>
        <h3>Votre Nom et prénom</h3>
        <div>
          <img height="250" src={Logo} /> 
        </div>
        <div style={{margin:'-20px 0 50px 0'}}>
        <p>Entrez votre nom et prénom</p>
        <input style={{padding:4, margin:4}} id='stepN1' type="text" onChange={this.handleChange} placeholder="Nom"/><br></br>
        <input style={{padding:4, margin:4}} id='stepN2' type="text" onChange={this.handleChange} placeholder="Prénom"/><br></br>
        {/*this.props.usertype=="teacher"?<input style={{padding:4, margin:4}} id='stepMatiere' type="text" onChange={this.handleChange} placeholder="Matière ou Classe"/>: <div></div>*/}
        </div>
      </div>
    );
  }
}
